import clsx from 'clsx'
import React from 'react'

import { ResponsiveImage } from '@/components/Shared/ResponsiveImage'
import type { CMSCollectionContentCardV2 } from '@/types/sanity'

import './Card.scss'
import { LinkButton } from '@/components/Link/LinkButton'

type Props = {
  content: CMSCollectionContentCardV2
}

export const CollectionContentCardV2: React.FC<Props> = ({ content }) => {
  const { theme, eyebrow, header, description, ctaConfig, image } = content

  const classes = ['collection-content-card', `theme-${theme}`]
  return (
    <div className={clsx(classes)}>
      <div className="collection-content-card__frame">
        <ResponsiveImage
          document={image}
          overrides={{
            desktopAspectRatio: 'auto',
            mobileAspectRatio: '16/9',
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="collection-content-card__body">
        <div className="collection-content-card__heading">
          {eyebrow && <div className="type-label">{eyebrow}</div>}
          {header && <div className="type-h5">{header}</div>}
          {description && <div className="type-body">{description}</div>}
        </div>
        {ctaConfig?.isVisible && (
          <LinkButton
            link={ctaConfig.cta}
            className="collection-content-card__cta type-label"
          />
        )}
      </div>
    </div>
  )
}
